import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { useColorModeValue } from "@chakra-ui/react";

import { Icon } from "components/Icon";
import { useGetThemeColors } from "ChakraTheme";

interface IProps {
  onOpen: () => void;
}

const HamburgerIcon = ({ onOpen }: IProps) => {
  const colors = useGetThemeColors();

  const color = useColorModeValue(colors.black, colors.white);

  return (
    <Icon
      w={30}
      h={30}
      icon={GiHamburgerMenu}
      color={color}
      cursor="pointer"
      onClick={onOpen}
    />
  );
};

export { HamburgerIcon };
